import { createReducer, on } from '@ngrx/store';
import { Agent } from 'src/app/client/agent-client/model/agent.model';

import { add, clean } from './agent.action';

const initialState: Agent = null;

export const agentReducer = createReducer(
  initialState,
  on(add, (state, { agent }) => agent),
  on(clean, () => initialState)
);
